import Swal from 'sweetalert2';

/* ─── Inject shared keyframe styles once ─── */
function injectStyles() {
  if (document.getElementById('stbb-auth-toast-styles')) return;
  const s = document.createElement('style');
  s.id = 'stbb-auth-toast-styles';
  s.textContent = `
    /* Strip all SweetAlert2 chrome from the popup container */
    .stbb-toast-popup {
      background: transparent !important;
      box-shadow: none !important;
      border: none !important;
      padding: 0 !important;
    }
    /* Timer bar overrides */
    .stbb-timer-green { background: linear-gradient(90deg,#10ac84,#0f6fad) !important; height: 3px !important; border-radius: 0 !important; }
    .stbb-timer-blue  { background: linear-gradient(90deg,#0f6fad,#8e44ad) !important; height: 3px !important; border-radius: 0 !important; }

    /* Card entrance — slides in from right */
    @keyframes stbbCardIn  { from { opacity:0; transform:translateX(32px) scale(0.96); } to { opacity:1; transform:translateX(0) scale(1); } }
    /* Card exit — slides out to right */
    @keyframes stbbCardOut { to   { opacity:0; transform:translateX(32px) scale(0.96); } }
    /* Avatar pop */
    @keyframes stbbPop     { from { transform:scale(0.4); opacity:0; } 60% { transform:scale(1.12); } to { transform:scale(1); opacity:1; } }
    /* Gradient shimmer on top bar */
    @keyframes stbbShimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
    /* Pulse ring around avatar */
    @keyframes stbbPulse   { 0%,100%{box-shadow:0 0 0 0 rgba(16,172,132,0.35)} 50%{box-shadow:0 0 0 10px rgba(16,172,132,0)} }

    .stbb-card-enter { animation: stbbCardIn  0.42s cubic-bezier(0.34,1.56,0.64,1) both; }
    .stbb-card-exit  { animation: stbbCardOut 0.28s ease forwards; }
    .stbb-avatar-pop { animation: stbbPop     0.55s cubic-bezier(0.34,1.56,0.64,1) 0.1s both; }
    .stbb-pulse-ring { animation: stbbPulse   2s ease-in-out infinite; }
  `;
  document.head.appendChild(s);
}

/* ─── Helper: 2-letter initials ─── */
function initials(name) {
  return (name || 'U').slice(0, 2).toUpperCase();
}

/* ─── Helper: current time string ─── */
function timeStr() {
  return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

/* ════════════════════════════════════════════════════
   WELCOME — shown after successful login
════════════════════════════════════════════════════ */
export function showWelcomeToast(username) {
  injectStyles();

  return Swal.fire({
    html: `
      <div class="stbb-card-enter" style="
        font-family:'Poppins',sans-serif;
        background:#fff;
        border-radius:18px;
        overflow:hidden;
        box-shadow:0 24px 64px rgba(0,0,0,0.13),0 4px 20px rgba(16,172,132,0.18);
        border:1px solid rgba(16,172,132,0.18);
        min-width:340px;
        max-width:380px;
      ">
        <!-- shimmer top bar -->
        <div style="
          height:4px;
          background:linear-gradient(90deg,#10ac84 0%,#3ee8b5 33%,#0f6fad 66%,#10ac84 100%);
          background-size:300% 100%;
          animation:stbbShimmer 2.4s linear infinite;
        "></div>

        <!-- main body -->
        <div style="padding:22px 22px 18px;display:flex;align-items:flex-start;gap:16px;">
          <!-- avatar -->
          <div class="stbb-avatar-pop stbb-pulse-ring" style="
            width:54px;height:54px;border-radius:15px;flex-shrink:0;
            background:linear-gradient(145deg,#10ac84 0%,#0f6fad 100%);
            display:flex;align-items:center;justify-content:center;
            color:#fff;font-weight:700;font-size:1.15rem;
            box-shadow:0 6px 18px rgba(16,172,132,0.45);
            letter-spacing:1px;
          ">${initials(username)}</div>

          <!-- text -->
          <div style="flex:1;min-width:0;">
            <div style="
              font-size:0.68rem;font-weight:700;text-transform:uppercase;
              letter-spacing:1.5px;color:#10ac84;margin-bottom:5px;
              display:flex;align-items:center;gap:6px;
            ">
              <span style="width:6px;height:6px;background:#10ac84;border-radius:50%;display:inline-block;box-shadow:0 0 0 3px rgba(16,172,132,0.2);"></span>
              Welcome back
            </div>
            <div style="font-size:1.08rem;font-weight:700;color:#0f172a;line-height:1.3;margin-bottom:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
              ${username} &nbsp;👋
            </div>
            <div style="font-size:0.73rem;color:#94a3b8;letter-spacing:0.01em;">
              STBB Portal &nbsp;·&nbsp; Signed in at ${timeStr()}
            </div>
          </div>
        </div>

        <!-- session bar -->
        <div style="
          margin:0 18px 18px;
          padding:10px 14px;
          background:linear-gradient(90deg,rgba(16,172,132,0.07),rgba(15,111,173,0.04));
          border-radius:10px;
          border-left:3px solid #10ac84;
          display:flex;align-items:center;gap:10px;
        ">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#10ac84" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          <span style="font-size:0.75rem;color:#059669;font-weight:600;">Secure session established</span>
        </div>
      </div>
    `,
    showConfirmButton: false,
    timer: 2800,
    timerProgressBar: true,
    background: 'transparent',
    padding: 0,
    width: 'auto',
    position: 'top-end',
    customClass: {
      popup: 'stbb-toast-popup',
      timerProgressBar: 'stbb-timer-green',
    },
    showClass:  { popup: '' },
    hideClass:  { popup: 'stbb-card-exit' },
  });
}

/* ════════════════════════════════════════════════════
   GOODBYE — shown on logout
════════════════════════════════════════════════════ */
export function showGoodbyeToast(username) {
  injectStyles();

  return Swal.fire({
    html: `
      <div class="stbb-card-enter" style="
        font-family:'Poppins',sans-serif;
        background:#fff;
        border-radius:18px;
        overflow:hidden;
        box-shadow:0 24px 64px rgba(0,0,0,0.13),0 4px 20px rgba(15,111,173,0.18);
        border:1px solid rgba(15,111,173,0.18);
        min-width:340px;
        max-width:380px;
      ">
        <!-- shimmer top bar -->
        <div style="
          height:4px;
          background:linear-gradient(90deg,#0f6fad 0%,#8e44ad 33%,#e84393 66%,#0f6fad 100%);
          background-size:300% 100%;
          animation:stbbShimmer 2.4s linear infinite;
        "></div>

        <!-- main body -->
        <div style="padding:22px 22px 18px;display:flex;align-items:flex-start;gap:16px;">
          <!-- icon -->
          <div class="stbb-avatar-pop" style="
            width:54px;height:54px;border-radius:15px;flex-shrink:0;
            background:linear-gradient(145deg,#0f6fad 0%,#8e44ad 100%);
            display:flex;align-items:center;justify-content:center;
            font-size:1.55rem;
            box-shadow:0 6px 18px rgba(15,111,173,0.38);
          ">👋</div>

          <!-- text -->
          <div style="flex:1;min-width:0;">
            <div style="
              font-size:0.68rem;font-weight:700;text-transform:uppercase;
              letter-spacing:1.5px;color:#0f6fad;margin-bottom:5px;
              display:flex;align-items:center;gap:6px;
            ">
              <span style="width:6px;height:6px;background:#0f6fad;border-radius:50%;display:inline-block;"></span>
              See you soon
            </div>
            <div style="font-size:1.08rem;font-weight:700;color:#0f172a;line-height:1.3;margin-bottom:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
              Goodbye, ${username}!
            </div>
            <div style="font-size:0.73rem;color:#94a3b8;letter-spacing:0.01em;">
              STBB Portal &nbsp;·&nbsp; Signed out at ${timeStr()}
            </div>
          </div>
        </div>

        <!-- security bar -->
        <div style="
          margin:0 18px 18px;
          padding:10px 14px;
          background:linear-gradient(90deg,rgba(15,111,173,0.07),rgba(142,68,173,0.04));
          border-radius:10px;
          border-left:3px solid #0f6fad;
          display:flex;align-items:center;gap:10px;
        ">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0f6fad" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <span style="font-size:0.75rem;color:#0f6fad;font-weight:600;">Session ended · Data cleared securely</span>
        </div>
      </div>
    `,
    showConfirmButton: false,
    timer: 2400,
    timerProgressBar: true,
    background: 'transparent',
    padding: 0,
    width: 'auto',
    position: 'top-end',
    customClass: {
      popup: 'stbb-toast-popup',
      timerProgressBar: 'stbb-timer-blue',
    },
    showClass:  { popup: '' },
    hideClass:  { popup: 'stbb-card-exit' },
  });
}
